export default "__VITE_ASSET__BKxeWLba__"